import { useTheme } from '../../theme/ThemeContext';
export const useInputStyles = ({
  isDisabled
}) => {
  const theme = useTheme();
  const inputStyle = {
    display: 'block',
    width: '100%',
    padding: '8px',
    fontSize: theme.fontSizes.lg,
    border: `1px solid ${theme.colors.border}`,
    borderRadius: theme.radius.sm,
    boxSizing: 'border-box',
    color: isDisabled ? theme.colors.textDisabled : theme.colors.text
  };
  return {
    inputStyle
  };
};